"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shape = void 0;
exports.Shape = {
    iconSize: 22,
    cardBorderRadius: 8,
    borderWidth: 0.5,
    rowHeight: 40,
    starIconSize: 14,
    headerHeight: 50,
    buttonBorderRadius: 7,
};
